import type { FastifyPluginAsync } from 'fastify'
import { adminRoutes } from './admin.routes.js'
import { gamificationAdminRoutes } from './gamification-admin.routes.js'
import { GamificationAdminController } from './gamification-admin.controller.js'
import { getFirestore } from '../../core/database/firebase.js'
import { redisClient } from '../../core/redis/client.js'

export const adminModule: FastifyPluginAsync = async (fastify) => {
  // Register general admin routes
  await fastify.register(adminRoutes)

  // Register gamification admin routes
  const firestore = getFirestore()
  const redis = redisClient
  const gamificationController = new GamificationAdminController(firestore, redis)

  await fastify.register(
    async (instance) => {
      await gamificationAdminRoutes(instance, gamificationController)
    },
    { prefix: '/gamification' }
  )

  // Rewards admin routes (used by Admin UI)
  await fastify.register(async (instance) => {
    const { adminRewardsRoutes } = await import('./admin.rewards.routes.js')
    await adminRewardsRoutes(instance, {})
  }, { prefix: '/rewards' })

  // Cost analytics routes
  await fastify.register(async (instance) => {
    const { adminCostRoutes } = await import('./admin.cost.controller.js')
    await adminCostRoutes(instance, {})
  }, { prefix: '/cost' })
}
